<script setup lang="ts">
const host = window.location.host
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div class="text-center max-w-md">
      <h1 class="text-7xl font-bold text-gray-900 mb-4">404</h1>
      <h2 class="text-2xl font-semibold text-gray-700 mb-3">Парк не найден</h2>
      <p class="text-gray-600 mb-6">
        Поддомен <strong class="text-gray-900">{{ host }}</strong> не привязан к парку
        в системе na12.
      </p>
      <a href="https://na12.ru" class="text-primary-600 hover:text-primary-900 font-medium">
        ← Перейти на na12.ru
      </a>
    </div>
  </div>
</template>
